<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-sub-title text="Módulo de Calidad"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <router-view></router-view>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({}),
    computed: {},
    methods: {},
}
</script>
